import { Grid2 } from "@mui/material";
import "./styles.scss";
import classNames from "classnames";

export const DualScreenLayout = ({
  left,
  right,
  collapseLeft = false,
  collapseRight = false,
}: {
  left: React.ReactNode;
  right: React.ReactNode;
  collapseLeft?: boolean;
  collapseRight?: boolean;
}) => {
  return (
    <Grid2 container columns={12} direction={"row"} minHeight={"100vh"}>
      <Grid2
        className={classNames("dual-screen-left", collapseLeft && "collapsed")}
        size={collapseLeft ? 0 : collapseRight ? 12 : 6}
        textAlign={"left"}
      >
        {!collapseLeft && left}
      </Grid2>

      <Grid2
        className={classNames(
          "dual-screen-right",
          collapseRight && "collapsed"
        )}
        size={collapseRight ? 0 : collapseLeft ? 12 : 6}
      >
        {!collapseRight && right}
      </Grid2>
    </Grid2>
  );
};
